<template>
    <div>
        <textarea :id="id" v-text="text"></textarea>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: 'TextEditor',
    emits: ['update:text'],
    data() {
        return {
            editor: null
        }
    },
    props: {
        text: String,
        id: String
    },

    watch: {
        text(newValue) {
            if (this.editor && this.editor.getData() !== newValue) {
                this.editor.setData(newValue || '');
            }
        },
    },
    // updated() {
    //     if (this.editor.getData() !== this.text)
    //         this.editor.setData(this.text);
    // },
    computed: {
        ...mapGetters({
            user: 'auth/getUser'
        })
    },
    mounted() {
        this.initializeEditor();
    },
    methods: {
        initializeEditor(){
            this.editor = window.CKEDITOR.replace(this.id, {toolbar: [
                { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike'] },
                { name: 'colors', items: ['TextColor', 'BGColor'] },
                { name: 'paragraph', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
                { name: 'insert', items: ['Image'] }, // 'Table'
                { name: 'tools', items: ['Maximize'] }
              ],
                filebrowserImageBrowseUrl: process.env.VUE_APP_API_BASE_URL + '/ly-lfm?type=Images&token=' + this.user.token,
                filebrowserImageUploadUrl: process.env.VUE_APP_API_BASE_URL + '/ly-lfm/upload?type=Images&_token=&token=' + this.user.token,
                filebrowserBrowseUrl: process.env.VUE_APP_API_BASE_URL + '/ly-lfm?type=Files&token=' + this.user.token,
                filebrowserUploadUrl: process.env.VUE_APP_API_BASE_URL + '/ly-lfm/upload?type=Files&_token=&token=' + this.user.token,
            });

            this.editor.on('change', () => {
                this.$emit('update:text', this.editor.getData());
            });

            if (this.text) {
                this.editor.setData(this.text);
            }
        },
        destroyEditor() {
            if (this.editor) {
                this.editor.destroy();
                this.editor = null;
            }
        },
    },
    beforeUnmount() {
        this.destroyEditor();
    },
}
</script>
